import useUserInfo from "../../Hooks/useUserInfo";
import { axiosApi } from "../../Api/Axios";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import VerifyCode from "../../Components/VerifyCode/VerifyCode";
import { useState } from "react";
import useGaEvent from "../../Hooks/useGaEvent";
import { decryptText } from "../../Helpers/Helper";

const RegisterVerify = () => {
  const { userInfo, setUserInfo } = useUserInfo();
  const [btnDisable, setBtnDisable] = useState(false);
  const [errMsg, setErrMsg] = useState("");
  const navigate = useNavigate();
  const dest = "/register/registerresult";
  const gaEvents = useGaEvent();


  const handleSubmit = async (e) => {
    e.preventDefault();
    // console.log(userInfo);

    if(userInfo.code?.trim() != null)
    {
      const vCode = userInfo.code?.trim();
      if(vCode.includes('.') || vCode.includes('-') || vCode.includes('e'))
      {
        setErrMsg("Only numbers 0-9 are allowed");
        return;
      }
    }

    try {
        setBtnDisable(true);
        const response = await axiosApi.post(
          "/api/auth/Register-verifyCode",
          {
            Code: userInfo.code?.trim(),
            VerifyToken: userInfo.accessToken,
            PwdTable:'R'
          },
          {
            headers: {
              "Accept": "application/json",
              "Content-Type": "application/json",
              "Authorization": "Bearer " + userInfo.accessToken,
            },
          }
        );

        // console.log(response.data);

        if (response.status === 200) {
          if(response.data.resultPass === false)
          {
              //No user found
              setUserInfo((prev) => {
                  // console.log(JSON.stringify(prev));
                  // console.log(response.data); //it is number
                  return {
                    tempWWWId: prev.tempWWWId,
                    accessToken: "",
                    regiReqNo: response.data.requestId,
                    failReason: response.data.statusDesc,
                  };
                });
              gaEvents.authRegisterNoUserFound();
          }else
          {
            //User found
            setUserInfo((prev) => {
                  // console.log(JSON.stringify(prev));
                  // console.log(response.data); //it is accessToken
                  return {
                    ...prev,
                    accessToken: response.data.atk,
                    wwwId: decryptText(response.data.wwwId, process.env.REACT_APP_Encrypt_Key, process.env.REACT_APP_Encrypt_IV),
                    regiReqNo: "",
                    failReason: null,
                  };
                });
          }

          navigate(dest, { replace: true });
        } else {
          setErrMsg(response.data);
          setBtnDisable(false);
        }
      } catch (err) {
        gaEvents.authRegisterFail();
        if(err.response.status === 401)
        {
          setErrMsg("Session Expired");
        }else
        {
          setErrMsg(err.response.data);
        }
        // console.log(err);
        setBtnDisable(false);
      }
    
  };

  return (
    <>
      {!userInfo.tempWWWId ? (
        <Navigate to="/register" replace={true} />
      ) : (
        <div className="register-container-bg">
          <VerifyCode handleSubmit={handleSubmit} errMsg={errMsg} btnDisable={btnDisable} />
        </div>
      )}
    </>
  );
};

export default RegisterVerify;
